import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

export const useSavedCards = (enabled: boolean) => {
  const apiClient = useApiClient(ClientApiClient)

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.deposit.savedCards(enabled),
    queryFn: () => apiClient.getEnabledCardDetails(),
    enabled,
  })

  const savedCards = Array.isArray(data) ? data : undefined

  return { savedCards, isLoading }
}
